import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';

interface EmployeeOnlyProps {
  children: React.ReactNode;
}

const EmployeeOnlyRoute: React.FC<EmployeeOnlyProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // If no authenticated user, redirect to the admin login page
  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  // If authenticated, render the requested element (e.g., AdminDashboard)
  return <>{children}</>;
};

export default EmployeeOnlyRoute;
